/**
 * @Author: v_huangyongxing@baidu.com
 * @Date: 2023-08-21 15:05:16
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2024-04-26 15:00:04
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageLargeModelSecurity.js
 * @Description: 大模型安全风控解决方案
 */
import React from 'react';
import PropTypes from 'prop-types';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';
import './pageAiSoc.less';
const structureData = [
    {
        imgSrc: require('../../asset/image/pageIntelligentDataSecurityGateway/yewu-cj1.png'),
        title: '客户挑战：',
        text1: '在常态化安全运营与重点活动保障场景中，客户面临以下核心痛点：',
        text2: [
            '告警过载：安全告警数量庞大，关键威胁难以快速识别',
            '研判困难：安全告警线索繁多，难以关联，研判难度大，效率受限',
            '响应迟缓：威胁响应依赖人工，流程长、速度慢，错过黄金时间',
            '经验难以服用：专业安全人员不足，专家经验未能体系化沉淀与复用'
        ]
    },
    {
        imgSrc: require('../../asset/image/pageIntelligentDataSecurityGateway/yewu-cj4.png'),
        title: '解决方案：',
        text1: '部署AISOC智能安全运营中心，构建覆盖全网安全告警的统一智能运营体系，实现以下关键成效：',
        text2: [
            '告警智能降噪：实现告警智能降噪，过滤无效告警超过90%',
            '告警智能研判：构建“Al预判+人工复核”模式，显著提升研判效率',
            '智能化处置：建立自动化安全智能体工作流，缩短响应时间',
            '构建行业标准：沉淀自动化处置模板，助力行业智能安全标准化'
        ]
    },
];

const PageCommercialPassword = props => {
    const bannerInfo = props.bannerInfo || {};
    const learnMoreItem = bannerInfo.learnMore.length === 1 ? bannerInfo.learnMore[0] || {} : {};

    return (
        <div className={'product Brain'}>
            <div className="pro-banner-box bg-new">
                <ProBanner
                    title={bannerInfo.title}
                    urlText={'商务咨询'}
                    bgImg={bannerInfo.bgImg}
                    url={bannerInfo.url}
                />
                {bannerInfo.nextText ? (
                    <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                        {bannerInfo.nextText}
                    </a>
                ) : null}
                {bannerInfo.learnMore.length
                    ? bannerInfo.learnMore.length === 1
                        ? bannerInfo.nextIndex === '0'
                            ? (<a href={learnMoreItem.content} target="_blank"
                                className="compliance-btn compliance-btn-border">
                                {learnMoreItem.title}
                            </a>) : (<a
                                href={learnMoreItem.content}
                                target="_blank"
                                className="compliance-btn compliance-btn-border"
                            >
                                {learnMoreItem.title}
                            </a>) : (<div className={'about-tab'}>
                            <div className={'about-slide'}>
                                <ul>
                                    {
                                        learnMore.map((item, index) => {
                                            return <li key={index}>
                                                <a href={item.content} target={'_blank'}>{item.title}</a>
                                            </li>;
                                        })
                                    }
                                </ul>
                            </div>
                            <div className={'tab-shadow'} />
                        </div>) : null}

            </div>
            <div className={'product-des'}>
                以人工智能为核心的新一代智能安全运营平台，
                以安全模型为基石，以海量安全告警为数据基础，
                结合多类型安全智能体协同，打造自动化“研判-分析-处置”的安全智能体工作流，
                并深度融合专家经验与人机协同机制，成为安全工程师的专家助手，
                助力其从繁重告警中释放精力，重塑安全运营生产力。
            </div>

            <div style={{marginTop: '1rem'}}>
                <div className={'product-mod'}>
                    <ProductTitle title={'行业痛点'} />
                </div>
                <div className={'product-mod'}>
                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>告警过载，真实威胁被淹没</div>
                            <div className={'profun-box-des'}>
                                大量无效告警淹没核心威胁，传统人工研判模式效率低下，导致安全团队疲于应对，却仍与高风险告警失之交臂。
                            </div>
                        </div>
                    </div>

                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>响应滞后，防御速度追不上攻击</div>
                            <div className={'profun-box-des'}>
                                攻击方利用大模型，传统规则防御难以招架。防御体系陷入“人力追不上算力，规则跑不赢变异”的困境，屡屡错失关键响应时机。
                            </div>
                        </div>
                    </div>

                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>基础设施复杂，全局防御难实现</div>
                            <div className={'profun-box-des'}>
                                云、容器、微服务等现代基础设施动态且复杂，攻击面瞬息万变，数据和安全工具分孤岛林立，无法构建有效的全局安全视野和统一安全防御。
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div className={'product-mod'}>
                    <ProductTitle title={'产品介绍'} />
                </div>
                <div className={'product-des'}>
                    平台围绕安全运营核心场景，打造了告警降噪、研判分析、事件响应、报告生成、情报解读及漏洞分析等一系列专业智能体，
                    同时通过智能体的自定义编排能力，可自主构建贴合需求的安全运营自动化工作流，提升安全运营效率与自动化水平。
                </div>
                <div>
                    <img src={require('../../asset/image/aiSoc/product.png')} alt=""
                        width={'95%'} height={'175px'}
                        style={{margin: '0 auto'}} />
                </div>
            </div>


            <div>
                <div className={'product-mod'} style={{paddingTop: '1rem'}}>
                    <ProductTitle title="核心功能" />
                </div>
                <div className={'product-mod'}>
                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>智能降噪智能体，从人工筛选到AI精准投递</div>
                            <div className={'profun-box-des'}>
                                基于AI对告警意图的深度理解，有效过滤无效告警、智能聚合相似告警，精准锁定关键威胁。
                            </div>
                        </div>
                    </div>

                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>告警研判及托管智能体，从海量筛选到自动托管</div>
                            <div className={'profun-box-des'}>
                                通过AI研判模型进行多维度关联分析，高效输出研判结论，并支持自动接管，将单条告警处理时间从数小时缩短至分钟级，结合专家经验实现高效精准的威胁判定。
                            </div>
                        </div>
                    </div>

                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>AI- SOAR，从自动化工具到智能安全分析师</div>
                            <div className={'profun-box-des'}>
                                AI深度赋能安全运营，实现告警自动分析、处置建议生成；支持安全智能体自定义编排，构建具备自主决策能力的安全智能体工作流。
                            </div>
                        </div>
                    </div>
                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>安全知识图谱，从孤立数据到全景视图</div>
                            <div className={'profun-box-des'}>
                                {/* eslint-disable-next-line max-len */}
                                基于自主可控图存储和计算引擎，将告警、资产、机器、进程、文件、人员、场景等多维数据的智能关联，实现攻击链的完整还原，
                                构建全景式资产、攻击、告警图谱，实现资产与风险的全域可视、可管、可控。
                            </div>
                        </div>
                    </div>
                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>事件调查与响应智能体，从小时级到分钟级响应</div>
                            <div className={'profun-box-des'}>
                                智能生成安全事件的标准化处置流程与分诊建议，将专家经验沉淀为可复用的运营策略，实现安全事件的自动化响应。
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{marginTop: '1rem'}}>
                <div className={'product-mod'}>
                    <ProductTitle title={'适用场景'} />
                </div>
                <div className={'product-mod'} style={{paddingBottom: 0}}>
                    {
                        [
                            {
                                'mobile_pic': require('../../asset/image/pageLargeModelSecurity/bg_card_1_wap.png'),
                                title: '常态化安全运营场景',
                                // eslint-disable-next-line max-len
                                content: '在日复一日的安全运营中，AISOC可自动处理无效告警，使团队从“告警海洋”中解脱，并实现告警自动闭环处置，将大量重复性、流程化工作交由AI接管，大幅提升日常运营效率。'
                            },
                            {
                                'mobile_pic': require('../../asset/image/pageLargeModelSecurity/bg_card_2_wap.png'),
                                title: '实战攻防演练场景',
                                content: '在红蓝对抗的极限压力下，AISOC将成为指挥中心的“最强大脑”，自动关联海量攻击线索，还原攻击链，帮助团队在分秒必争的演练中快速定位攻击意图与范围。'
                            },
                            {
                                'mobile_pic': require('../../asset/image/pageLargeModelSecurity/bg_card_3_wap.png'),
                                title: '重大活动保障场景',
                                // eslint-disable-next-line max-len
                                content: '在需要万无一失的重大活动保障期间，通过预设的运营策略，实现“无人化”或“少人化”高效值守，打破数据孤岛，为保障指挥部提供全域、可视化的安全态势总览，是确保安全防线稳固、响应及时的定心丸。'
                            },
                        ].map((item, index) => {
                            return <div
                                className={'pro-applicable'}
                                key={index}
                                style={{backgroundImage: `url(${item.mobile_pic})`}}
                            >
                                <div className={'pro-app-title'}>
                                    {item.title}
                                </div>
                                <div className={'pro-app-content'} style={{fontSize: '0.3rem'}}>
                                    {item.content}
                                </div>
                            </div>;
                        })
                    }
                </div>
            </div>

            <div>
                <div className={'product-mod'} style={{marginTop: '1rem'}}>
                    <ProductTitle title="核心优势" />
                </div>
                <div className="saas-p-advantage">
                    {
                        [
                            {
                                title: '精准告警研判',
                                des: ['过滤无效告警，聚焦真实威胁', '高效完成告警分析与自动化研判', '提供可解释的告警根因与完整研判依据，决策透明可信'],
                                url: require('../../asset/image/pageSecAwarenrssSolution/icon_zhuanye.svg')
                            },
                            {
                                title: '全天候自动安全值守',
                                des: ['构建人机协同机制，全天候安全值守', '提供全程可追溯的处置记录'],
                                url: require('../../asset/image/pageSecAwarenrssSolution/icon_duoyang.svg')
                            },
                            {
                                title: '丰富的实战经验',
                                des: ['百度内部AI安全最佳落地实践', '历经丰富真实场景打磨，贴合企业实际安全运营需求'],
                                url: require('../../asset/image/pageSecAwarenrssSolution/icon_chuangxin.svg')
                            },
                            {
                                title: '懂安全的智能体',
                                // eslint-disable-next-line max-len
                                des: ['基于海量高质量安全数据训练，具备精准威胁推理能力', '模型内化完备的安全知识体系，具备对威胁的深刻理解', '基于研判结果与专家反馈学习，实现智能体能力不断进化'],
                                url: require('../../asset/image/pageSecAwarenrssSolution/icon_wanzheng.svg')
                            },
                            {
                                title: '灵活可扩展架构',
                                // eslint-disable-next-line max-len
                                des: ['广泛的数据兼容性， 兼容主流安全产品与数据源，支持多源异构数据快速接入', '具备灵活的集成能力，支持第三方安全工具、模型快速接入'],
                                url: require('../../asset/image/pageBrain/icon_jishuzhicheng.svg')
                            },
                            {
                                title: '全栈技术可控',
                                // eslint-disable-next-line max-len
                                des: ['基于文心、deepseek、通义千问通用大模型，构建坚实可靠的大模型基座', '应用百度自研超大规模图数据库HugeGraph，底层技术自主掌控'],
                                url: require('../../asset/image/page_app_solution/icon_quanmianfanghu.svg')
                            }

                        ].map((item, index) => {
                            return (
                                <div key={index} className="saas-p-advantage-item">
                                    <div className="icon" style={{backgroundImage: `url(${item.url})`}}></div>
                                    <div className="content">
                                        <div className="title">{item.title}</div>
                                        <div className="des" style={{marginLeft: '0.2rem'}}>
                                            <ul>
                                                {item.des.map((desItem, desIndex) => {
                                                    // eslint-disable-next-line max-len
                                                    return <li key={desIndex} className="des-item" style={{listStyleType: 'disc'}}>{desItem}</li>;
                                                })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>

            <div>
                <div className={'product-mod'} style={{padding: '1rem 0 0', background: '#f5f7f9'}}>
                    <ProductTitle title="客户案例" />
                    <h2 style={{textAlign: 'center', padding: '15px 0'}}>(能源行业案例)</h2>
                </div>
                <div>
                    {
                        structureData.map(({imgSrc, title, text1, text2, imgWidth}, index) => {
                            return <div className={(index + 1) % 2 === 0 ? 'structure hui' : 'structure'} key={index}>
                                <div
                                    className={'shadow'}
                                >
                                    <div className={'imgBor'} style={{width: imgWidth ? imgWidth : '100%'}}>
                                        <img
                                            src={imgSrc}
                                            alt={title}
                                        />
                                    </div>
                                </div>
                                <div className={'title'}>
                                    {title}
                                </div>
                                <div className={'text'}>
                                    {text1}
                                </div>
                                <div className={'text'}>
                                    {Array.isArray(text2) ? text2.map((item, idx) => {
                                        return <div key={idx} style={{marginBottom: '0.2rem'}}>• {item}</div>;
                                    }) : null}
                                </div>
                            </div>;
                        })
                    }
                </div>
            </div>

            <div className="saas-app-solution-contact">
                <div className="saas-app-solution-contact-inner">
                    <div className="des" style={{paddingTop: '1.2rem'}}>
                        联系我们立即获取免费技术专家咨询
                    </div>
                    <a href={bannerInfo.url} className="btn" style={{marginTop: '.76rem'}}>
                        立即咨询
                    </a>
                </div>
            </div>
        </div>
    );

};

PageCommercialPassword.propTypes = {
    bannerInfo: PropTypes.object
};

export default PageCommercialPassword;



// WEBPACK FOOTER //
// ./src/containers/product/pageAiSoc.js